import React from 'react'
import { Heading, GContainer, Seachbar, Input, CustomBsSearch } from '../../style/Navbar'
import { CustomDiv } from '../../style/shared'

export const Navbar = (props) => {
    return (
        <GContainer>
            <Heading>
                {props.Heading ? props.Heading : "Patient chart"}
            </Heading>
            <Seachbar>
                <CustomBsSearch />
                <Input placeholder="Search" />
            </Seachbar>

            <span style={{ fontSize: "14px", marginTop: "20px", paddingLeft: "12px", paddingRight: "12px",fontWeight:600, fontFamily: 'Montserrat, SemiBold' }}>Provider: TOM COLLINS</span>
        </GContainer>
    )
}
